import React, { useEffect, useState } from 'react';
import classes from './ProfilePage2.module.css';
import { getProfileApi, unsubscribeAPI } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { removeUserDetails } from '../../store/slices/userSlice';
import Header2 from '../../component/NewComponents/Header2';
import { FaFutbol, FaArrowRightFromBracket, FaPen, FaLanguage, FaBan } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import UnsubModal2 from '../../component/NewComponents/UnsubModal2';

const ProfilePage2 = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [modal, setModal] = useState(false);
    const [unsubLoading,setUnsubLoading]=useState(false);

    const { userDetails } = useSelector(state => state.persisted?.userSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { t } = useTranslation();

    const fetchUserProfile = async () => {
        try {
            setLoading(true);
            const response = await getProfileApi(userDetails?.token);
            setProfile(response?.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(
                t("20")
            );
        }
    };

    useEffect(() => {
        fetchUserProfile();
    }, []);

    const logoutHandler = () => {
        dispatch(removeUserDetails());
        navigate('/');
    };

    const unsubscribeUser = async () => {
        try {
            setUnsubLoading(true);
            const response = await unsubscribeAPI(userDetails?.msisdn);
            setUnsubLoading(false);

            logoutHandler();
            toast.success(t("255"));
        } catch (error) {
            setUnsubLoading(false);

            toast.error(t("20"));
        }
    }


    return (
        <div className={classes.page}>
            <Header2 active={4} />

            <main className={classes.main}>

                {/* ── Hero bar ── */}
                <div className={classes.heroBar}>
                    <div className={classes.heroText}>
                        <span className={classes.heroEyebrow}>{t("164")}</span>
                        <h1 className={classes.heroTitle}>{t("180")} <em>{t("181")}</em></h1>
                    </div>
                    <div className={classes.heroMeta}>
                        <span className={classes.profileChip}>
                            <FaFutbol className={classes.chipIcon} />
                            {t("165")}
                        </span>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className={classes.body}>

                    {/* ── Profile card ── */}
                    <div className={classes.profileCard}>
                        <div className={classes.cardBg} />

                        <div className={classes.avatarWrap}>
                            {loading ? (
                                <div className={classes.avatarSkeleton} />
                            ) : profile?.image ? (
                                <img src={profile.image} alt={profile?.name || 'User'} className={classes.avatarImg} />
                            ) : (
                                <div className={classes.avatarFallback}>
                                    <span className={classes.avatarInitials}>
                                        {profile?.name
                                            ? profile.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
                                            : '?'}
                                    </span>
                                </div>
                            )}
                            <div className={classes.avatarRing} />
                        </div>

                        <div className={classes.cardInfo}>
                            {loading ? (
                                <>
                                    <div className={classes.skeletonName} />
                                    <div className={classes.skeletonSub} />
                                </>
                            ) : (
                                <>
                                    <p className={classes.cardName}>{profile?.name || t("166")}</p>
                                    <p className={classes.cardSub}>{t("167")} &amp; {t("168")}</p>
                                </>
                            )}
                        </div>
                    </div>

                    {/* ── Menu groups ── */}
                    <div className={classes.menuGroups}>

                        <div className={classes.group}>
                            <span className={classes.groupLabel}>{t("169")}</span>
                            <div className={classes.menuCard}>
                                <button
                                    type="button"
                                    className={classes.menuItem}
                                    onClick={() => navigate('/edit-profile')}
                                >
                                    <div className={`${classes.iconBox} ${classes.iconBlue}`}>
                                        <FaPen className={classes.itemIcon} />
                                    </div>
                                    <div className={classes.itemText}>
                                        <span className={classes.itemTitle}>{t("170")}</span>
                                        <span className={classes.itemSub}>{t("171")} &amp; {t("172")}</span>
                                    </div>
                                    <span className={classes.chevron}>›</span>
                                </button>

                                <div className={classes.menuDivider} />

                                <button
                                    type="button"
                                    className={classes.menuItem}
                                    onClick={() => navigate('/my-matches')}
                                >
                                    <div className={`${classes.iconBox} ${classes.iconGreen}`}>
                                        <FaFutbol className={classes.itemIcon} />
                                    </div>
                                    <div className={classes.itemText}>
                                        <span className={classes.itemTitle}>{t("173")}</span>
                                        <span className={classes.itemSub}>{t("174")}</span>
                                    </div>
                                    <span className={classes.chevron}>›</span>
                                </button>


                                <div className={classes.menuDivider} />

                                <button
                                    type="button"
                                    className={classes.menuItem}
                                    onClick={() => navigate('/languages')}
                                >
                                    <div className={`${classes.iconBox} ${classes.iconPurple}`}>
                                        <FaLanguage className={classes.itemIcon} color='purple' />
                                    </div>
                                    <div className={classes.itemText}>
                                        <span className={classes.itemTitle}>{t("175")}</span>
                                        <span className={classes.itemSub}>{t("176")}</span>
                                    </div>
                                    <span className={classes.chevron}>›</span>
                                </button>

                            </div>
                        </div>

                        <div className={classes.group}>
                            <span className={classes.groupLabel}>{t("177")}</span>
                            <div className={classes.menuCard}>
                                <button
                                    type="button"
                                    className={classes.menuItem}
                                    onClick={logoutHandler}
                                >
                                    <div className={`${classes.iconBox} ${classes.iconRed}`}>
                                        <FaArrowRightFromBracket className={classes.itemIcon} />
                                    </div>
                                    <div className={classes.itemText}>
                                        <span className={`${classes.itemTitle} ${classes.logoutTitle}`}>{t("178")}</span>
                                        <span className={classes.itemSub}>{t("179")}</span>
                                    </div>
                                    <span className={classes.chevron}>›</span>
                                </button>

                                <div className={classes.menuDivider} />

                                <button
                                    type="button"
                                    className={classes.menuItem}
                                    onClick={() => setModal(true)}
                                >
                                    <div className={`${classes.iconBox} ${classes.iconRed}`}>
                                        <FaBan className={classes.itemIcon} />
                                    </div>
                                    <div className={classes.itemText}>
                                        <span className={`${classes.itemTitle} ${classes.logoutTitle}`}>{t("250")}</span>
                                        <span className={classes.itemSub}>{t("251")}</span>
                                    </div>
                                    <span className={classes.chevron}>›</span>
                                </button>

                            </div>
                        </div>

                    </div>
                </div>

            </main>

            {modal && <UnsubModal2 setModal={setModal} unsubscribeUser={unsubscribeUser} unsubLoading={unsubLoading} />}
        </div>
    );
};

export default ProfilePage2;